import React from 'react';

// Formulár na pridávanie/editovanie záznamov pre Evidenciu Práce
const EvidenciaPraceForm = ({
  newEntry,
  setNewEntry,
  handleAddEntry,
  companies,
}) => {

  return (
    <div className="entry-form">
      <h2>Nový záznam</h2>
      <div className="form-grid">
        <div className="form-group">
          <label>Firma *</label>
          <input
            type="text"
            list="companies-list"
            value={newEntry.companyName}
            onChange={(e) => setNewEntry({ ...newEntry, companyName: e.target.value })}
            placeholder="Názov firmy"
          />
          <datalist id="companies-list">
            {companies.map(company => (
              <option key={company} value={company} />
            ))}
          </datalist>
        </div>
        <div className="form-group">
          <label>Dátum *</label>
          <input
            type="date"
            value={newEntry.date}
            onChange={(e) => setNewEntry({ ...newEntry, date: e.target.value })}
          />
        </div>
        <div className="form-group">
          <label>Obdobie od * <span style={{ color: '#dc2626', fontSize: 11 }}>(povinné)</span></label>
          <input
            type="month"
            value={newEntry.workPeriodFrom || ''}
            onChange={(e) => setNewEntry({ ...newEntry, workPeriodFrom: e.target.value })}
            style={{ borderColor: newEntry.workPeriodFrom ? undefined : '#fca5a5' }}
          />
        </div>
        <div className="form-group">
          <label>Obdobie do <span style={{ color: '#64748b', fontSize: 11 }}>(nepovinné — ak sa práca týka viacerých mesiacov)</span></label>
          <input
            type="month"
            value={newEntry.workPeriodTo || ''}
            onChange={(e) => setNewEntry({ ...newEntry, workPeriodTo: e.target.value })}
            min={newEntry.workPeriodFrom || undefined}
          />
        </div>
        <div className="form-group">
          <label>Popis práce *</label>
          <input
            type="text"
            value={newEntry.description}
            onChange={(e) => setNewEntry({ ...newEntry, description: e.target.value })}
            placeholder="Napr. Účtovanie dokladov za júl"
          />
        </div>
        <div className="form-group">
          <label>Počet / množstvo</label>
          <input
            type="number"
            step="0.01"
            min="0"
            value={newEntry.quantity ?? newEntry.minutes ?? 0}
            onChange={(e) => setNewEntry({ ...newEntry, quantity: parseFloat(e.target.value) || 0 })}
            placeholder="napr. 1"
          />
        </div>
        <div className="form-group">
          <label>Cena / jedn. (€)</label>
          <input
            type="number"
            step="0.01"
            value={newEntry.unitPrice}
            onChange={(e) => setNewEntry({ ...newEntry, unitPrice: parseFloat(e.target.value) || 0 })}
          />
        </div>

        <div className="form-group full-width">
          <label>Poznámka * <span style={{ color: '#dc2626', fontSize: 11 }}>(povinné — uveďte konkrétny detail, napr. meno pracovníka)</span></label>
          <input
            type="text"
            value={newEntry.note}
            onChange={(e) => setNewEntry({ ...newEntry, note: e.target.value })}
            placeholder="Napr. Prihlásenie: Ján Novák, nar. 1990"
            style={{ borderColor: newEntry.note ? undefined : '#fca5a5' }}
          />
        </div>
      </div>
      <button onClick={handleAddEntry} className="btn-add">Pridať záznam</button>
    </div>
  );
}

export default EvidenciaPraceForm;
